/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Ocop_Mobile_Title1Inputs */

const vi_sitesettings_ocop_mobile_title1 = /** @type {(inputs: Sitesettings_Ocop_Mobile_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề OCOP (điện thoại)`)
};

/**

* @param {Sitesettings_Ocop_Mobile_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_ocop_mobile_title1 = /** @type {((inputs?: Sitesettings_Ocop_Mobile_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Ocop_Mobile_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_ocop_mobile_title1(inputs)
});
export { sitesettings_ocop_mobile_title1 as "siteSettings_ocop_mobile_title" }